import { TestimonialsContent, TestimonialCard as TestimonialCardType } from './types';

export const css = `
  .testimonials-section {
    background: var(--c-secondary-0);

    .testimonial-card::before {
      content: '“';
      font-size: 64px;
      font-family: 'Lora', serif;
      position: absolute;
      top: 2.5rem;
      left: 1rem;
      color: var(--c-secondary-2);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='currentColor' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      color: var(--c-primary-7);
      opacity: 0.5;
      z-index: 0;
     }
  }
`;

const TestimonialCard = ({ data }: { data: TestimonialCardType }) => (
  <div class="testimonial-card rounded-2xl p-12 flex flex-col gap-8 relative shadow-lg shadow-gray-200 bg-white">
    <p class="testimonial-text text-xl relative z-10 leading-relaxed font-serif italic">
      {data.quote}
    </p>
    <div class="flex items-center gap-4">
      <div class="testimonial-author-image shrink-0 size-14 rounded-full overflow-hidden border-2">
        {data.author.image.src && (
          <img
            src={data.author.image.src}
            alt={data.author.image.alt}
            class="w-full h-full object-cover text-transparent"
            loading="lazy"
          />
        )}
      </div>
      <div>
        <h4 class="testimonial-author-name font-semibold text-lg">{data.author.name}</h4>
        <p class="testimonial-author-role text-sm opacity-50">{data.author.role}</p>
      </div>
    </div>
  </div>
);

export const View = ({ data }: { data: TestimonialsContent }) => (
  <section id="testimonials" class="testimonials-section py-24 relative">
    <div class="max-w-7xl mx-auto px-8 relative z-10">
      <div class="text-center mb-16">
        <h2 class="testimonial-author-name text-4xl font-bold mb-5">{data.heading.title}</h2>
        <p class="testimonial-text max-w-2xl mx-auto">{data.heading.subtitle}</p>
      </div>

      <div class="testimonials-grid grid md:grid-cols-3 gap-6">
        {data.testimonials.map((testimonial) => (
          <TestimonialCard key={testimonial.id} data={testimonial} />
        ))}
      </div>
    </div>
  </section>
);
